import { luscinia } from "./luscinia";
import { ChangeElement, ChangeType, getPostValueChangeConfig } from "./postValueChanged";

export async function deleteRecords(url: string, ids: string[], afterDelete: () => void) {
    const modalTitle = ids.length > 1 ? luscinia.config.translations.captionConfirmDeleteRecordsTitle : luscinia.config.translations.captionConfirmDeleteRecordTitle;
    const modalBody = ids.length > 1 ? luscinia.config.translations.captionConfirmDeleteRecords.replace("{0}", ids.length.toString()) : luscinia.config.translations.captionConfirmDeleteRecord;

    luscinia.showConfirmationDialog(
        modalTitle,
        modalBody,
        async () => {
            await Promise.all(ids.map(id => deleteRecord(url, id)));
            afterDelete();
        }
    );
};

async function deleteRecord(url: string, id: string) {
    const response = await fetch(url.toLowerCase() + "/" + id, {
        method: "DELETE"
    })
    
    if (response.ok) {
        const recordDeletedEvent = new CustomEvent("recordDeleted", { detail: { id: id } });
        document.dispatchEvent(recordDeletedEvent);
        luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationRecordDeleted, "warning");
    } else {
        let message = "An unknown error occurred while deleting the error";
        const json = await response.json();
        if (json[0].message) {
            message = json[0].message;
        } else if (typeof json === "string") {
            message = json   
        }

        luscinia.showNotification(luscinia.config.translations.captionNotification, message, "danger");
    }
};

luscinia.unDelete = function (softRecordId) {
    $.ajax({
        type: 'PUT',
        url: "undelete/" + softRecordId
    });
};

luscinia.runCrudAction = function (actionName: string, element: HTMLElement = null) {
    let form = luscinia.getActiveForm();
    let crudUrl = form.attr("data-luscinia-modulepath");

    let formData = luscinia.serializeFormObject(form);
    if (element != null && element.classList.contains("btn-editGrid-custom")) {
        insertEditGridDataIntoFormData(form, formData, element);
    }

    return $.ajax({
        method: "POST",
        cache: false,
        contentType: false,
        processData: false,
        url: crudUrl + `/action/${actionName}`,
        data: formData
    }).done(function (formActions: any) {
        luscinia.executeActionList(formActions, form);
    });
};

luscinia.getActiveForm = function () {
    let editInlineForm = $("#editInline").find("form");
    
    let layerId = luscinia.getModalLayerCount();
    let modalFormIdentifier = "#editModal" + layerId + "Form";
    let form = $(modalFormIdentifier);
    if (form.length === 0) {
        layerId = luscinia.getModalLayerCount() - 1;
        modalFormIdentifier = "#editModal" + layerId + "Form";
        form = $(modalFormIdentifier);
    }
    if (form.length > 0) {
        return form as JQuery<HTMLFormElement>;
    }
    else if (editInlineForm.length > 0) {
        return editInlineForm;
    }
    else if ($("#wizardFormId").length > 0) {
        return $("#wizardFormId");
    }
    return getTopMostForm();
}

function insertEditGridDataIntoFormData(form: any, formData: FormData, element: HTMLElement) {
    const currentEditGrid = $(element).closest(".editGrid");
    const rowName = currentEditGrid.attr("data-property-prefix");
    getPostValueChangeConfig(form, formData, rowName, undefined, ChangeType.Action, ChangeElement.EditGridRow, getEditGridPostValueChangeObject(currentEditGrid));    
}

export function getEditGridPostValueChangeObject(currentEditGrid: JQuery<HTMLElement>) {
    let postValueChangeObject = {};

    $(currentEditGrid).find(":input[name^='parameter']").each(function () {
        const originalName = $(this).attr("name");
        const splitName = originalName.split("-");
        const propertyName = splitName[splitName.length - 1];
        if (propertyName === "EditGridRowConfig") {
            postValueChangeObject[propertyName] = JSON.parse($(this).val() as string);
        } else {
            postValueChangeObject[propertyName] = luscinia.getLocalizedElementValue($(this));
        }
    });

    return postValueChangeObject;
}

function getTopMostForm() {
    let forms = document.querySelectorAll('form');
    if (forms.length === 0) {
        throw new Error("No forms were found");
    }
    let topForm = null;
    let highestZIndex = 0;

    forms.forEach(form => {
        let zIndex = parseInt(window.getComputedStyle(form).zIndex);
        if (zIndex > highestZIndex) {
            highestZIndex = zIndex;
            topForm = form;
        }
    });

    return topForm;
}
luscinia.isCRUDPage = function () {
    return $('.crud-page').length > 0;
}

luscinia.deleteCustomRecord = function (url, id, onSuccess) {
    luscinia.showConfirmationDialog(luscinia.config.translations.captionConfirmDeleteRecordTitle, luscinia.config.translations.captionConfirmDeleteRecord, async (e) => {
        if ($(e.target).data("luscinia-value") === true) {
            const response = await fetch(url.toLowerCase() + "/" + id, {
                method: "DELETE"
            })
            
            if (response.ok) {
                if (typeof onSuccess !== 'undefined' && onSuccess !== null) {
                    onSuccess();
                    const recordDeletedEvent = new CustomEvent("recordDeleted", { detail: { id: id } });
                    document.dispatchEvent(recordDeletedEvent);
                }
                luscinia.showNotification(luscinia.config.translations.captionNotification, luscinia.config.translations.captionNotificationRecordDeleted, "warning");
            } else {
                let message = "An unknown error occurred while deleting the error";
                const json = await response.json();
                if (json[0].message) {
                    message = json[0].message;
                } else if (typeof json === "string") {
                    message = json   
                }

                luscinia.showNotification(luscinia.config.translations.captionNotification, message, "danger");
            }
        }
    });
};